// @ts-nocheck

import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
import dash_api from '../../main/support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import type { AudienceDownloadRequestPayload } from '../types/audienceTypes';
import NotificationActions from './NotificationActions';
const AUDIENCE_PATH = '/v1/audience';
const AUDIENCE_DOWNLOAD_PATH = '/v1/audience-download';
const errorProvider = new ErrorProvider();
const GetAudiencesForAudienceSegment = new ReduxAsyncAction('GET_AUDIENCES_FOR_AUDIENCE_SEGMENT');
GetAudiencesForAudienceSegment.registerRequest(function (audienceSegmentId: string) {
  return dash_api.get(AUDIENCE_PATH + `/${audienceSegmentId}`).then(({ data }) => data);
});
export const GET_AUDIENCES_FOR_AUDIENCE_SEGMENT = GetAudiencesForAudienceSegment.constants;
export const getAudiencesForAudienceSegment =
  (audienceSegmentId: string) => async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(GetAudiencesForAudienceSegment.request(audienceSegmentId));
    } catch (err) {
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
// This async api should not make its way to Redux, and should instead return a Promise as written
export async function downloadAudienceBySegmentVersionAndLinkName({
  segmentId,
  versionId,
  dataDate,
  linkName,
}: AudienceDownloadRequestPayload): Promise<any> {
  return dash_api.get(AUDIENCE_DOWNLOAD_PATH + `/${segmentId}/${versionId}/${dataDate}/${linkName}`).catch((err) => {
    err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
  });
}
